import styles from './styles.module.scss'; // THIS HAS TO BE ON TOP BECAUSE REASONS, just don't touch it, okay
import React, { useEffect } from 'react';
import { Layout } from 'antd';
import Footer from './Footer';
import Header from './Header';
import { useGlobalDesignContext } from 'context/GlobalDesignContext';
import LanguageButtons from 'components/LanguageButtons';
import { SpecialClientEnumsType, SpecialClientInterface } from './types';
const { Content } = Layout;

const designStyleKey = (design?: string): keyof typeof styles | undefined => {
    if (!design) {
        return undefined;
    }
    return design as keyof typeof styles;
};

const DefaultUnauthorizedLayout: React.FC<any> = ({ children, className, showLanguageChange }) => {
    const { logo, setLogo, favicon, setFavicon, appearance, appearanceLoaded } = useGlobalDesignContext();

    const values = appearance.values;
    const replace = appearance.replace;

    useEffect(() => {
        if (!appearanceLoaded || replace) {
            return;
        }

        if (!logo) {
            setLogo(values?.logo ?? '/cs-logo.svg');
        }

        if (!favicon) {
            setFavicon(values?.favicon ?? '/favicon.ico');
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [appearanceLoaded, replace, values]);

    const handleClient = (key: keyof SpecialClientInterface): string | undefined => {
        if (replace) {
            window.location.replace(replace);
            return undefined;
        }

        if (!values) {
            return undefined;
        }

        if (key === SpecialClientEnumsType.design) {
            const designKey = designStyleKey(values.design);
            return designKey ? (styles as any)[designKey] : undefined;
        }

        return (values as any)[key];
    };

    return (
        <div className={styles.container}>
            <Header handleValues={handleClient} />
            <Content
                className={
                    handleClient(SpecialClientEnumsType.design) +
                    ' ' +
                    (className ?? '') +
                    ' ' +
                    styles.content
                }
            >
                {children}
                {showLanguageChange && (
                    <div className={styles.languageButtons}>
                        <LanguageButtons />
                    </div>
                )}
            </Content>
            <Footer handleValues={handleClient} />
        </div>
    );
};

export default DefaultUnauthorizedLayout; //;
